<a [routerLink]="['/home']" class="logo logo-light trendi-logo --light">
  <span class="logo-lg">
    <img src="../../../assets/images/v2/svg/logo.svg" alt="Logo Trendmulti light" />
  </span>
  <span class="logo-sm">
    <img src="../../../assets/images/v2/svg/logo-sm.svg" alt="Logo Trendmulti light" />
  </span>
</a>

<a [routerLink]="['/home']" class="logo logo-dark trendi-logo --dark">
  <span class="logo-lg">
    <img src="../../../assets/images/v2/svg/logo-dark.svg" alt="Logo Trendmulti dark" />
  </span>
  <span class="logo-sm">
    <img src="../../../assets/images/v2/svg/logo-dark-sm.svg" alt="Logo Trendmulti dark" />
  </span>
</a>

<div class="button-sm-hover" data-bs-toggle="tooltip" data-bs-placement="right">
  <i class="ri-checkbox-blank-circle-line align-middle"></i>
</div>

<div class="button-close-fullsidebar" (click)="closeSidebar()">
  <i class="ri-close-fill align-middle"></i>
</div>

<div class="h-100" id="leftside-menu-container" data-simplebar #menuContainer>
  @if(sidebarMenu.length > 0) {
  <ul class="side-nav" id="sideNavAccordion">
    @for(item of sidebarMenu; track item.label) {
    @if (item.isActive && !item.subItems) {
    <li class="side-nav-item" [routerLinkActive]="item.isActive ? 'menuitem-active' : ''" (click)="closeSidebar()">
      <a [routerLink]="[item.route]" class="side-nav-link">
        <i class="{{ item.icon }}"></i>
        <span> {{ item.label | translate }} </span>
        @if (item.badge) {
        <span class="badge text-bg-warning ms-1">{{ item.badge | translate }}</span>
        }
      </a>
    </li>
    } @else if (item.isActive && item.subItems) {
    <li class="side-nav-item">
      <a data-bs-toggle="collapse" [href]="'#' + item.subItemLabel" aria-expanded="false"
        class="side-nav-link collapsed">
        <i class="{{ item.icon }}"></i>
        <span> {{ item.label | translate }} </span>
        <span class="menu-arrow"></span>
      </a>
      <div class="collapse" [id]="item.subItemLabel" data-bs-parent="#sideNavAccordion">
        <ul class="side-nav-second-level">
          @for(subItem of item.subItems; track subItem.label) {
          @if (subItem.isActive) {
          <li>
            <a [routerLink]="[subItem.route]">{{ subItem.label | translate }}</a>
          </li>
          }
          }
        </ul>
      </div>
    </li>
    }
    }
  </ul>
  }
  <!-- Trendmulti mobile app promo: pinned to the bottom when the menu is short, follows it when the menu scrolls -->
  <mobile-app-promo class="d-block mt-auto" (opened)="closeSidebar()" />
  <div class="clearfix"></div>
</div>